import React from 'react';
import { Icon } from '@iconify/react';

interface TransportTypeOption {
  value: string;
  label: string;
  icon: React.ReactNode;
  description: string;
}

interface TransportTypeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  description?: string;
  isDisabled?: boolean;
  noTooltip?: boolean;
}

const transportOptions: TransportTypeOption[] = [
  {
    value: 'M',
    label: 'MARÍTIMO',
    icon: <Icon icon='tabler:ship' className='text-lg' />,
    description: 'Transporte por mar',
  },
  {
    value: 'A',
    label: 'AÉREO',
    icon: <Icon icon='tabler:plane' className='text-lg' />,
    description: 'Transporte aéreo',
  },
  {
    value: 'T',
    label: 'TERRESTRE',
    icon: <Icon icon='tabler:truck' className='text-lg' />,
    description: 'Transporte terrestre',
  },
];

const TransportTypeSelector: React.FC<TransportTypeSelectorProps> = ({
  value,
  onChange,
  description,
  isDisabled = false,
  noTooltip = false,
}) => {
  return (
    <div className='space-y-2'>
      <label className='text-sm font-medium text-default-600'>Tipo</label>

      {/* Horizontal Icon-Only Buttons */}
      <div className='flex flex-row gap-2'>
        {transportOptions.map((option) => (
          <button
            key={option.value}
            type='button'
            onClick={() => !isDisabled && onChange(option.value)}
            disabled={isDisabled}
            className={`
                relative p-3 rounded-lg border transition-all duration-200 
                flex items-center justify-center flex-1 h-12 group
                ${
                  isDisabled
                    ? 'opacity-50 cursor-not-allowed'
                    : 'cursor-pointer hover:shadow-md'
                }
                ${
                  value === option.value
                    ? 'border-blue-500 bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400 shadow-sm'
                    : 'border-divider bg-background text-default-400 hover:border-divider hover:text-default-600'
                }
              `}
          >
            {option.icon}

            {/* Tooltip */}
            {!noTooltip && (
              <div className='absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-default-800 dark:bg-default-400 text-white dark:text-black text-xs rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap'>
                <div className='font-medium'>{option.label}</div>
                {/* Tooltip arrow */}
                <div className='absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-default-800 dark:border-t-default-200'></div>
              </div>
            )}

            {/* Small selection indicator */}
            {value === option.value && (
              <div className='absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full'></div>
            )}
          </button>
        ))}
      </div>

      {/* Description */}
      {description && (
        <p className='text-xs text-default-500 mt-2 leading-tight'>
          {description}
        </p>
      )}
    </div>
  );
};

export default TransportTypeSelector;
